import { createAction } from '@reduxjs/toolkit';

export default createAction(
  'scheduler/scheduleActionRequested',
  function prepare(action) {
    return {
      payload: { actionToSchedule: action },
    };
  }
);
